const translationsHost = process.env.TRANSLATIONS_HOST

/***/
export function* importLanguage(locale) {
  let opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }
  let url = translationsHost + locale + '.json'

  const nestedMessages = yield fetch(url, opts)
    .then(checkStatus)
    .then((response) => response.json())
  // const nestedMessages = yield import(`../../assets/i18n/${ locale }.json`)
  return flattenMessages(nestedMessages)
}
/***/
function flattenMessages(nestedMessages, prefix = '') {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    let value = nestedMessages[key]
    let prefixedKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === 'string') {
      messages[prefixedKey] = value
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey))
    }

    return messages
  }, {})
}
/**
 *  Check the status of the fetch response
 *  @param   {object}  response  The response
 *  @throws  {Error}             If the server response is not "positive",
 *                               throws an error with server message
 *                               explanation
 *  @return  {object}            The success response
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    return response.json().then((json) => Promise.reject(json))
  }
}
